export default __webpack_public_path__ + "static/media/024.5fa42be0.jpg";